// extracted by mini-css-extract-plugin
module.exports = {"snackBar":"message_snackBar__r0xru","error":"message_error__njTQg"};